export const socialLinks = [
	{
		id: 1,
		name: 'Google Scholar',
		icon: 'globe',
		url: 'https://scholar.google.com/citations?hl=en&user=svr8v24AAAAJ&view_op=list_works&sortby=pubdate',
	},
	{
		id: 2,
		name: 'ORCID',
		icon: 'user',
		url: 'https://orcid.org/0000-0002-3394-1750',
	},
	// {
	// 	id: 3,
	// 	name: 'Twitter',
	// 	icon: 'twitter',
	// 	url: 'https://twitter.com/realstoman',
	// },
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/jiyoungis/',
	},
	// {
	// 	id: 5,
	// 	name: 'YouTube',
	// 	icon: 'youtube',
	// 	url: 'https://www.youtube.com/c/realstoman',
	// },
];
